(function() {

    /*
     *  Prevent document's default scroll behaviour on space
     */
    window.onkeydown = function(e) {
        if (e.keyCode == 32 && $(e.target).hasClass('ui-grid-focuser')) {
            e.preventDefault();
            return false;
        }
    };


    angular.module('SMART2')
        .directive("uigridCompatible", ['uiGridConstants', 'uiGridEditConstants', '$rootScope', uigridCompatibleFunc]);

    function uigridCompatibleFunc(uiGridConstants, uiGridEditConstants, $rootScope) {
        return {
            require: ['?^uiGrid', '?^uiGridRenderContainer'],
            restrict: 'A',
            link: function(scope, element, attrs, controllers) {
                var uiGridCtrl = controllers[0];
                var renderContainerCtrl = controllers[1];

                var isFocused = false;
                var isSelectElement = false;

                /*
                 *  Remove previous cell scope if any
                 */
                if (window.lastRenderedElementScope) {
                    try {
                        window.lastRenderedElementScope.stopEdit();
                        window.lastRenderedElementScope = undefined;
                    }
                    catch (e) { }
                }

                window.lastRenderedElementScope = scope;

                /*
                 *  On popup close listener
                 */
                var onPopupClosed = $rootScope.$on("popupClosed", function () {
                    uiGridCtrl.focus();
                });

                /*
                *  On date component close listener
                */
                var onDatePopupClosed = $rootScope.$on("closedPopup", function () {
                    uiGridCtrl.focus();
                });

                /*
                 *  On popup open listener
                 */
                var onPopupOpened = $rootScope.$on("popupOpened", function () {
                    document.activeElement.blur();
                });

                /*
                 *  Viewport keydown broadcast listener
                 */
                var onViewPortKeyDown = uiGridCtrl.grid.api.cellNav.on.viewPortKeyDown(scope, function (e, rowCol) {
                    var inputText = element.find("input");
                    var anchor = element.find("a");

                    switch (e.keyCode) {
                        case 32:
                            if (anchor.length > 0) {
                                window.isPopupOpenedByUIGridCompatibleElement = true;
                                anchor.trigger("click");
                            }
                            else if (inputText.length > 0 && !isFocused) {
                                inputText.focus();
                                isFocused = true;
                            }
                            else if (isSelectElement) {
                                select.focus();
                            }
                            break;
                        case 9:
                            scope.stopEdit();
                            break;
                        default:
                            if (element.attr("type") !== "date") {
                                inputText.focus();
                            }
                            break;
                    }
                });

                /*
                 *  Stop cell editing and destroy the scope
                 */
                scope.stopEdit = function (e) {
                    if (isSelectElement) {
                        select.blur();
                    }
                    scope.$emit(uiGridEditConstants.events.END_CELL_EDIT);
                };


                /*
                 *  Element key down handler
                 */
                var onElementKeyDown = function (e) {
                    switch (e.keyCode) {
                        case 32:
                            var inputText = element.find("input");
                            var anchor = element.find("a");

                            if (anchor.length > 0) {
                                window.isPopupOpenedByUIGridCompatibleElement = true;
                                anchor.trigger("click");
                            }
                            else if (isSelectElement) {
                                select.focus();
                            }
                            break;
                        case uiGridConstants.keymap.ESC:
                            e.stopPropagation();
                            scope.$emit(uiGridEditConstants.events.CANCEL_CELL_EDIT);
                            break;
                    }
                    if (uiGridCtrl && uiGridCtrl.grid.api.cellNav) {
                        e.uiGridTargetRenderContainerId = renderContainerCtrl.containerId;
                        if (uiGridCtrl.cellNav.handleKeyDown(e) !== null) {
                            scope.stopEdit(e);
                        }
                    }
                    else {
                        //handle enter and tab for editing not using cellNav
                        switch (e.keyCode) {
                            case uiGridConstants.keymap.ENTER: // Enter (Leave Field)
                            case uiGridConstants.keymap.TAB:
                                scope.stopEdit(e);
                                break;
                        }
                    }
                };

                element.on('keydown', onElementKeyDown);


                //  Focus select element
                var select = element.find("select");
                isSelectElement = select.length > 0;
                if (isSelectElement) {
                    setTimeout(function () {
                        select.focus();
                    });
                }



                //  Trigger anchor tag's click event if cell clicked
                if (window.isCellClicked) {
                    setTimeout(function () {
                        var anchor = element.find("a");
                        if (anchor.length > 0) {
                            window.isPopupOpenedByUIGridCompatibleElement = true;
                            anchor.trigger('click');
                        }
                    });
                    window.isCellClicked = false;
                }


                /*
                 *  Destroy broadcast listeners on scope destroy
                 */
                scope.$on('$destroy', function () {
                    onPopupClosed();
                    onDatePopupClosed();
                    onPopupOpened();
                    onViewPortKeyDown();
                    element.off('keydown', onElementKeyDown);
                });
            }
        };
    };
})();
